module.exports = __webpack_public_path__ + "img/jinggao.10821a49.png";